// extracted by mini-css-extract-plugin
export default {"wrapper":"ChartWrapper_wrapper__K0ut7","headerWrapper":"ChartWrapper_headerWrapper__v3nvC","icon":"ChartWrapper_icon__oxRZm","chartWrapper":"ChartWrapper_chartWrapper__t-Ocs"};